import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import messages from './AdditionalInformationComponent.messages';

import metadata from './AdditionalInformationComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';
//import styles from '../Miscellanous.module.scss'

function AdditionalInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, offeringCode, boatVm, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('AdditionalInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true;

    const waterCraftTypePath = `${pathUpdated.substring(0, pathUpdated.lastIndexOf('.'))}.boatInformation.value.watTypFie`;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        doYouReqGuaRepCosGGRCFie: {
            visible: _.get(submissionVM, waterCraftTypePath) === 'PerWat',
            required: _.get(submissionVM, waterCraftTypePath) === 'PerWat'
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AdditionalInformationComponent.propTypes = wizardProps;
export default withRouter(AdditionalInformationComponent);
